import { render, staticRenderFns } from "./TagTaxonomyIds.vue?vue&type=template&id=12a2b870&"
import script from "./TagTaxonomyIds.vue?vue&type=script&lang=ts&"
export * from "./TagTaxonomyIds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports